import { useNavigate, useParams } from "react-router-dom";
import DocxViewer from "../../components/DocxViewer";
import { getTermsByType } from "../../utils/termsConfig";
import "./css/termsDetail.css";

const TermsDetail = () => {
  const navigate = useNavigate();
  const { type } = useParams();
  const termsInfo = getTermsByType(type);
  const title = termsInfo?.title || "약관";

  if (!termsInfo) {
    return (
      <div className="terms-detail-container">
        <div className="terms-detail-header">
          <button className="terms-back-btn" onClick={() => navigate(-1)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="terms-title">약관</h1>
        </div>
        <div className="terms-detail-content">
          <p>약관을 찾을 수 없습니다.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-detail-container">
      <div className="terms-detail-header">
        <button className="terms-back-btn" onClick={() => navigate(-1)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="terms-title">{title}</h1>
      </div>
      <DocxViewer fileName={termsInfo.file} />
    </div>
  );
};

export default TermsDetail;